import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LevelsGrid = ({ data, onSelect }: any) => {
    const [gridData, setGridData] = useState(data);
    useEffect(() => {
        setGridData(data);
    }, [data]);

    const handleClick = (clickedItem: any) => {
        const newData = gridData.map((item: any) => {
            if (item.value === clickedItem.value) {
                return { ...item, selected: !item.selected };
            }
            return { ...item, selected: false };
        });

        setGridData(newData);

        if (onSelect) {
            onSelect(newData);
        }
    };

    return (
        <section className="course-category-two">
            <div className="container">
                <div className="row">
                    {gridData.map((x: any, index: number) => {
                        return (
                            <div
                                key={index}
                                className="col-xl-3 col-lg-4 col-sm-6 d-flex"
                                onClick={() => handleClick(x)}
                            >
                                <div
                                    className={`category-item-2 h-100 w-100 d-flex flex-column ${
                                        x.selected ? "bg-success" : ""
                                    }`}
                                >
                                    <div className="cat-icon border border-white mx-auto d-flex justify-content-center align-items-center">
                                        <img src={x.icon} alt={x.name} loading="lazy" />
                                    </div>
                                    <h5 className="mb-1">
                                        <Link to="#">{x.name}</Link>
                                    </h5>
                                    {x.hasOwnProperty("description") && (
                                        <p className="flex-grow-1">{x.description}</p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default LevelsGrid;